export { default } from '../../rewards/birthday';
export * from '../../rewards/birthday';
